<template>
  <a v-html="benefitsIcon" href="/benefiti" class="benefits-nav-link"></a>
</template>

<script>
import { benefits } from '@/components/common/icons/svgIcons'

export default {
  name: 'benefits-nav-link',
  computed: {
    benefitsIcon () {
      return benefits
    }
  }
}
</script>

<style scoped lang="scss">
.benefits-nav-link {
  display: block;
  text-decoration: none;
  outline: none;
  width: 2.4rem;
  min-width: 2.4rem;
  height: 2.4rem;
  font-weight: bold;

  @media (map_get($breakpoints, sm)) {
    //display: none;
    margin-left: 4rem;
  }

  /deep/ .icon-background {
    fill: transparent;
    transition: fill 150ms;
  }

  /deep/ .icon-foreground {
    fill: $primary;
  }

  &:hover /deep/ .icon-background {
    fill: $primary;
  }
}
</style>
